
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staking",
      function () {
        return require("private-next-pages/staking.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staking"])
      });
    }
  